<template>

    <div class="participant-menu">

        <b-row>
            <b-col :cols="showAsAccordion ? 12 : 4" class="col col-dashboard-buttons">
                <b-list-group class="dashboard-buttons">

                    <!-- My Mindset (My Well-being) -->

                    <b-list-group-item class="dashboard-button__button" to="/mindset"
                                       :active="currentPath == '/mindset'">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="sun"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_MINDSET') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/mindset'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Habits -->

                    <b-list-group-item class="dashboard-button__button" to="/habits"
                                       :active="currentPath == '/habits'">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="clock"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_HABITS') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/habits'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Goals -->

                    <b-list-group-item class="dashboard-button__button" to="/goals"
                                       :active="currentPath == '/goals'">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="flag"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_GOALS') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/goals'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Path -->

                    <b-list-group-item class="dashboard-button__button" to="/path"
                                       :active="currentPath == '/path'"
                                       v-if="$utils.themeIs('wellcoaches')">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="arrow-top"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_PATH') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/path'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Logs -->

                    <b-list-group-item class="dashboard-button__button" to="/metrics"
                                       :active="currentPath == '/metrics'">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="graph"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_METRICS') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/metrics'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Notes -->

                    <b-list-group-item class="dashboard-button__button" to="/notes"
                                       :active="currentPath == '/notes'">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="pencil"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_NOTES') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/notes'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Resources -->

                    <b-list-group-item class="dashboard-button__button" to="/resources"
                                       :active="currentPath == '/resources'">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="document"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_RESOURCES') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/resources'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Questionnaires -->

                    <b-list-group-item class="dashboard-button__button" to="/questionnaires"
                                       :active="currentPath == '/questionnaires'">
                        <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="question-mark"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_QUESTIONNAIRES') }}
                        <my-questionnaire-list-badge class="ml-4">
                        </my-questionnaire-list-badge>
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/questionnaires'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Lifestyle -->

                    <b-list-group-item class="dashboard-button__button" to="/lifestyle"
                                       :active="currentPath == '/lifestyle'">
                            <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="heart"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_LIFESTYLE') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/lifestyle'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Appointments -->

                    <b-list-group-item class="dashboard-button__button" to="/appointments"
                                       :active="currentPath == '/appointments'">
                        <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="calendar"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_APPOINTMENTS') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/appointments'">
                        <slot></slot>
                    </b-list-group-item>

                    <!-- My Reports -->

                    <b-list-group-item class="dashboard-button__button" to="/reports"
                                       :active="currentPath == '/reports'">
                        <span class="icon-wrapper icon-wrapper-left">
                                <shs-icon name="pie-chart"></shs-icon>
                            </span>
                        {{ $i18n.gt('HEADING_MY_REPORTS') }}
                    </b-list-group-item>

                    <b-list-group-item v-if="showAsAccordion && currentPath == '/reports'">
                        <slot></slot>
                    </b-list-group-item>

                </b-list-group>
            </b-col>

            <!-- display main page content here at larger sizes -->

            <b-col v-if="!showAsAccordion">
                <slot>
                </slot>
            </b-col>
        </b-row>

    </div>

</template>

<script>

/**
 * Navigation component for patient pages - mimics an accordion at smaller sizes, and displays
 * a left sidebar menu at larger sizes. The component should be wrapped around the main page
 * content.
 *
 * Note that the main page content is displayed in different slots depending on screen size -
 * on mobile as an accordion, and on desktop as a side menu plus center content.
 */

import Vue from 'vue'

export default Vue.extend({
    name: 'ParticipantMenu',
    computed: {
        currentPath() {
            return this.$route.path
        },
        showAsAccordion() {
            return this.$mq == 'sm' || this.$mq == 'md' || this.$mq == 'lg'
        },
        inProduction () {
            return this.$api.inProduction
        }
    },
})

</script>

<style lang="scss">

@import '../../sass/base';

// ACCORDION TRANSITIONS
@media (max-width: 959px) {
    .dashboard-buttons div.list-group-item {
        overflow: hidden;
    }

    @keyframes grow {
        0% {
            max-height: 0;
        }
        100% {
            max-height: 1000px;
        }
    }

    .dashboard-buttons div.list-group-item {
        animation: .7s ease-in-out 0s 1 grow;
    }
}

.col-dashboard-buttons {
    @media (min-width: 960px) {
        max-width: 320px !important;
    }
}

.dashboard-buttons {
    margin: 0 auto !important;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    padding: 0;
    background-color: #fff;

    @media (max-width: 767px) {
        flex-wrap: wrap;
        .icon-wrapper-left {
            margin-right: 1em;
        }
    }

    @media (min-width: 768px) and (max-width: $mobile-width) {
        position: relative;
        z-index: 1;
        left: 0;
        width: 100%;
    }

    @media (min-width: $mobile-width + 1px) {
        margin-bottom: 2em;
        .navbar-nav {
            width: 100%;
            justify-content: space-between;
        }
    }

    @media($mobile-width) {
        height: 100%;
        width: 52px;
    }

    a {
        &:hover {
            text-decoration: none;
        }

        @media (min-width: 576px) {
            padding-left: 1rem;
            padding-right: 1rem;
        }

        @media (min-width: 1200px) {
            font-size: 14px;

            .icon-wrapper-left {
                margin-right: 1em;
            }
        }

        @media (max-width: 959px) {
            &:hover {
                background-color: var(--accent-color-lighten-40);
                color: var(--blue);

                .icon-wrapper {
                    use {
                        fill: #fff;
                    }
                }
            }

            &:focus, &.active {
                color: #fff;
                border-color: var(--blue);
                background-color: var(--blue);

                .icon-wrapper {
                    background-color: #fff;

                    use {
                        fill: var(--blue);
                    }
                }
            }
        }

        @media (min-width: 960px) {
            @include transition(all .2s);
            background-color: #fff;
            position: relative;
            border: solid 1px #ddd;
            text-transform: uppercase;
            /*text-align: center;*/
            font-size: 13px;
            color: #666;

            .icon-wrapper, use {
                @include transition(all .2s);
            }

            &:hover {
                color: var(--blue);
                background-color: var(--accent-color-lighten-40);

                .icon-wrapper {
                    use {
                        fill: #fff;
                    }
                }
            }

            &:focus, &.active {
                color: #fff;
                border-color: var(--blue);
                background-color: var(--blue);

                .icon-wrapper {
                    background-color: #fff;

                    use {
                        fill: var(--blue);
                    }
                }
            }
        }

        /*@media (min-width: 768px) and (max-width: 1199px) {
            .icon-wrapper {
                height: 30px;
                width: 30px;
                line-height: 30px;

                svg {
                    height: 12px;
                    width: 12px;
                }
            }
        }*/

    }

    > li {
        list-style: none;
        @media (max-width: 600px) {
            width: 50%;
            font-size: 14px;
        }

        @media (min-width: 601px) and (max-width: 767px) {
            width: 33.333%;
        }
    }

    .icon-wrapper {
        position: relative;
    }
}

.dashboard-button__button {
    font-size: 18px;
    display: flex !important;
    align-items: center;

    svg {
        @include absolute-center;
    }
}

.home-participant {
    .dashboard-buttons {
        @media (min-width: 960px) {
            height: 70vh;
            max-width: 300px;
            max-height: 600px;
        }

        a {
            @media (min-width: 960px) {
                display: flex !important;
                padding: 0 1rem;
                height: 100%;
            }
        }
    }

    .participant-menu {
        @media (min-width: 960px) {
            padding-top: 0;
            > .row {
                align-items: center;
            }
        }
    }
}

.participant-menu {
    @media (min-width: 992px) {
        padding-top: 2rem;
    }
}

</style>
